module.exports = __webpack_public_path__ + "static/img/new.8e250d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/new.png
// module id = c1mo
// module chunks = 1